// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_cnAGL","title":"index_title_f6q3C","tv":"index_tv_9f7ZR","screen":"index_screen_GyVGo","btn":"index_btn_6Wqgz","logo":"index_logo_WeKi1"};